/* 拥堵色值 */
const congestionColors = [{
  desc: '畅通',
  color: '#2AB352',
  bgColor: 'rgba(42,179,82,0.06)'
}, {
  desc: '基本畅通',
  color: '#2AB352',
  bgColor: 'rgba(42,179,82,0.06)'
}, {
  desc: '轻度拥堵',
  color: '#F47A23',
  bgColor: 'rgba(244,122,35,0.06)'
}, {
  desc: '中度拥堵',
  color: '#F47A23',
  bgColor: 'rgba(244,122,35,0.06)'
}, {
  desc: '严重拥堵',
  color: '#FF4B4B',
  bgColor: 'rgba(255,75,75,.06)'
}];

/* 区域拥堵指数评价区间：畅通<1.3、基本畅通1.3-1.5、轻度拥堵1.5-1.8，中度拥堵1.8-2.2、严重拥堵>2.2 */

function regionalCongestionLevel(idx) {
  const level = idx >= 2.2 ? '严重拥堵' : idx >= 1.8 ? '中度拥堵' : idx >= 1.5 ? '轻度拥堵' : idx >= 1.3 ? '基本畅通' : '畅通';
  return level;
}
/* 道路拥堵指数评价区间：畅通<1.5、基本畅通1.5-1.8、轻度拥堵1.8-2.5，中度拥堵2.5-4、严重拥堵>4 */
function roadCongestionLevel(idx) {
  const level = idx >= 4 ? '严重拥堵' : idx >= 2.5 ? '中度拥堵' : idx >= 1.8 ? '轻度拥堵' : idx >= 1.5 ? '基本畅通' : '畅通';
  return level;
}

/* 根据指数描述获取色值
** 返回 array
*/
function getCongestionColor(state) {
  const colors = congestionColors.filter((item) => item.desc === state);
  return colors;
}

/*
* 拥堵指数趋势
* |A-B|<0.05 大致持平
* A-B>=0.05  拥堵加剧
* A-B<=-0.05 拥堵消散
* last1sum  当前数据
* last2sum  上批次数据
*/
function getIdxTrendIcon(last1sum = 0, last2sum = 0) {
  const diffRatio = (Number(last1sum) - Number(last2sum)).toFixed(2);
  let iconStyle = {
    iconColor: '',
    iconClass: ''
  };
  const delta = 1e-5;
  if (diffRatio > 0) {
    if ((diffRatio - 0.05) < delta || diffRatio > 0.05) {
      iconStyle.iconColor = '#FF4B4B';
      iconStyle.iconClass = 'ic-trianglearr-up-s';
    } else {
      iconStyle = {};
    }
  } else if (diffRatio < 0) {
    if (Math.abs(diffRatio) - 0.05 < delta || Math.abs(diffRatio) > 0.05) {
      iconStyle.iconColor = '#2AB352';
      iconStyle.iconClass = 'ic-trianglearr-down-s';
    } else {
      iconStyle = {};
    }
  } else {
    iconStyle = {};
  }
  return iconStyle;
}

/*
* 里程趋势
* |A-B|/B<5%  大致持平
* A-B>=5%     拥堵加剧
* A-B<=-5%    拥堵消散
* last1sum     当前数据
* last2sum     上批次数据
 */
function getMileageIcon(last1sum = 0, last2sum = 0) {
  const diffRatio = ((last1sum - last2sum) / last2sum).toFixed(1);
  let iconStyle = {
    iconColor: '',
    iconClass: ''
  };
  const delta = 1e-5;
  if (diffRatio > 0) {
    if ((diffRatio - 0.05) < delta || diffRatio > 0.05) {
      iconStyle.iconColor = '#FF4B4B';
      iconStyle.iconClass = 'ic-trianglearr-up-s';
    } else {
      iconStyle = {};
    }
  } else if (diffRatio < 0) {
    if (Math.abs(diffRatio) - 0.05 < delta || Math.abs(diffRatio) > 0.05) {
      iconStyle.iconColor = '#2AB352';
      iconStyle.iconClass = 'ic-trianglearr-down-s';
    } else {
      iconStyle = {};
    }
  } else {
    iconStyle = {};
  }
  return iconStyle;
}

/**
 * 距离数字美化
 * @param num
 * @param unit
 * @param isEng
 * 小于1000米取整数，大于1000米转化成千米保留1位小数
 * 注：value与unit样式不同时不可用
 * @returns {string}
 */
function distanceBeautifyNum(num, unit = '', isEng = false) {
  if (num < 1000) {
    return `${Number(num).toFixed(0)}${unit}`;
  }
  if (Number((num / 1000).toFixed(1) % 1 === 0)) {
    return `${Number((num / 1000).toFixed(0)).toLocaleString()}${isEng ? 'k' : '千'}${unit}`;
  }
  return `${Number((num / 1000).toFixed(1)).toLocaleString()}${isEng ? 'k' : '千'}${unit}`;
}

/**
 * 距离数字格式化
 * 在小于1000时加上小数，但整体不超过3位
 * @param num
 * @returns {string}
 */
function distanceNum(num) {
  num = Number(num);
  if (num >= 1000) {
    num /= 1000;
  }

  if (num < 10) {
    return num.toFixed(2) * 100 / 100;
  }
  if (num < 100) {
    return num.toFixed(1) * 10 / 10;
  }
  return num.toFixed(0) * 1;
}

// 拥堵趋势样式
const congestTrendColors = {
  1: {
    desc: '趋向平稳',
    color: '#f47a23',
    bgColor: 'rgba(244,122,35,0.06)'
  },
  2: {
    desc: '趋向严重',
    color: '#ff4b4b',
    bgColor: '#FFF3F0'
  },
  3: {
    desc: '趋向疏通',
    color: '#2AB352',
    bgColor: '#E9F7ED'
  }
};

/*
* 生成唯一id
* */
function processID() {
  const uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0; const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
  return uuid;
}

export default {
  congestionColors,
  congestTrendColors,
  regionalCongestionLevel,
  getCongestionColor,
  roadCongestionLevel,
  getIdxTrendIcon,
  getMileageIcon,
  distanceBeautifyNum,
  distanceNum,
  processID
};
